import { FieldDef, TemplateDefinition } from './types'

const COL12 = 'col-xs-12'

function text(key: string, label: string, col: string = COL12, extra: Partial<FieldDef> = {}): FieldDef {
  return { key, kind: 'text', label, col, ...extra }
}

function str(key: string, label: string, col: string = COL12, extra: Partial<FieldDef> = {}): FieldDef {
  return { key, kind: 'string', label, col, ...extra }
}

const generalPractitionerControlV001: TemplateDefinition = [
  { h3: 'Anamnesis próxima' },
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Anamnesis remota' },
  { shared: 'basic_measure_fields' },
  { row: [text('physical-exam', 'Examen físico')] },
  { h3: 'Seguimiento' },
  { row: [text('current-state', 'Estado actual')] },
  { row: [text('indications', 'Indicaciones')] },
  { h3: 'Emisión de Recetas, Exámenes y Derivaciones' },
  { shared: 'recipe_fields' },
]

const generalPractitionerControlV002: TemplateDefinition = [
  { h3: 'Anamnesis próxima' },
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Examen Físico' },
  { shared: 'basic_measure_fields' },
  { row: [text('physical-exam', 'Examen físico')] },
  { h3: 'Seguimiento' },
  { row: [text('current-state', 'Estado actual')] },
  { h3: 'Emisión de Recetas, Exámenes y Derivaciones' },
  { shared: 'recipe_fields' },
]

const generalPractitionerControlV003: TemplateDefinition = [
  { h3: 'Anamnesis próxima' },
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Examen Físico' },
  { h4: 'Métricas e indicadores' },
  { shared: 'basic_measure_fields_v2' },
  {
    row: [
      text('neurological', 'Examen neurológico y mental', 'col-xs-12 col-sm-6', {
        rows: 8,
        help: '(Atención, orientación, conciencia, memoria, sueño, lenguaje, juicio)',
        heading: 'Examen neurológico y mental',
      }),
      text('physical-exam', 'Examen regional', 'col-xs-12 col-sm-6', {
        rows: 8,
        help: '(Cara, boca, faringe, cuello, tórax, abdomen, extremidades)',
        heading: 'Examen regional',
      }),
    ],
  },
  { h3: 'Seguimiento' },
  { row: [text('current-state', 'Evolución y estado actual', COL12, { rows: 8 })] },
  { h3: 'Emisión de Recetas, Exámenes y Derivaciones' },
  { shared: 'recipe_fields' },
]

const generalPractitionerFirstSessionV001: TemplateDefinition = [
  { h3: 'Anamnesis próxima' },
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Anamnesis remota' },
  { shared: 'basic_measure_fields' },
  { row: [text('morbid-antecedents', 'Antecedentes mórbidos')] },
  {
    row: [
      text('other-antecedents', 'Otros Antecedentes', 'col-md-6 col-xs-12', {
        help: '(Quirúrgicos, ginecológicos, psiquiátricos, epidemológicos, sociales)',
      }),
      text('habits', 'Habitos', 'col-md-6 col-xs-12', { help: '(Alcohol, drogas, alimenticios, sueño, actividad física, sexuales)' }),
    ],
  },
  { h3: 'Examen físico' },
  { shared: 'physical_analysis_fields' },
  { h3: 'Hipotesis diagnóstica' },
  { row: [text('diagnosis', 'Diagnostico')] },
  { row: [text('indications', 'Indicaciones')] },
  { shared: 'notes_section' },
  { h3: 'Emisión de Recetas, Exámenes y Derivaciones' },
  { shared: 'recipe_fields' },
]

const generalPractitionerFirstSessionV002: TemplateDefinition = [
  { h3: 'Anamnesis próxima' },
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Anamnesis remota' },
  { row: [text('morbid-antecedents', 'Antecedentes mórbidos')] },
  { row: [text('habits', 'Habitos')] },
  { h3: 'Examen físico' },
  { shared: 'basic_measure_fields' },
  { shared: 'physical_analysis_fields' },
  { h3: 'Hipotesis diagnóstica' },
  { row: [text('diagnosis', 'Diagnostico')] },
  { h3: 'Emisión de Recetas, Exámenes y Derivaciones' },
  { shared: 'recipe_fields' },
]

const generalPractitionerFirstSessionV003: TemplateDefinition = [
  { h3: 'Anamnesis próxima' },
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Anamnesis remota' },
  { row: [text('morbid-antecedents', 'Antecedentes mórbidos', COL12, { help: '(Médicos, quirúrgicos, traumatismos)' })] },
  {
    row: [
      text('other-antecedents', 'Otros Antecedentes', 'col-md-6 col-xs-12', { help: '(Psiquiátricos, sociales)' }),
      text('habits', 'Hábitos', 'col-md-6 col-xs-12', { help: '(Drogas, alimenticios, sueño, deporte, medicamentos)' }),
    ],
  },
  { h3: 'Examen físico' },
  { h4: 'Métricas e indicadores' },
  { shared: 'basic_measure_fields_v2' },
  { h4: 'Examen regional' },
  { shared: 'physical_analysis_fields' },
  { h4: 'Examen neurológico y mental' },
  {
    row: [
      text('neurological', 'Examen neurológico y mental', COL12, {
        rows: 8,
        help: '(Atención, orientación, conciencia, memoria, sueño, lenguaje, juicio)',
      }),
    ],
  },
  { h3: 'Hipotesis diagnóstica' },
  { row: [text('diagnosis', 'Diagnóstico', COL12, { rows: 8 })] },
  { h3: 'Emisión de Recetas, Exámenes y Derivaciones' },
  { shared: 'recipe_fields' },
]

const kinesiologistPhysicalExamRows: TemplateDefinition = [
  {
    row: [
      text('general-condition', 'Condición general', COL12, {
        help: '(Evaluación postural, estado actual del paciente, elementos de estabilización)',
      }),
    ],
  },
  { row: [text('pain-location', 'Ubicación dolor', 'col-xs-6', { help: '' }), text('pain-type', 'Tipo de dolor', 'col-xs-6', { help: '' })] },
  { row: [text('inflamation', 'Inflamación', COL12, { help: '(Signos clínicos, perímetros articulares)' })] },
  {
    row: [
      text('sensibility', 'Sensibilidad', 'col-xs-6', { help: '(Epicrítica, protopática)' }),
      text('articular', 'Articular', 'col-xs-6', { help: '(ROM pasivo/activo, End feel)' }),
    ],
  },
  { row: [text('muscular', 'Muscular', COL12, { help: '(Fuerza muscular, longitud muscular, trofismo muscular)' })] },
  {
    row: [
      text('prospection', 'Propiocepción', 'col-xs-6', { help: '(Tensión y/o estiramiento muscular)' }),
      text('funcional-evaluation', 'Evaluación funcional', 'col-xs-6', { help: '(Marcha, subir y bajar escaleras)' }),
    ],
  },
]

const kinesiologistControlV001: TemplateDefinition = [
  { h3: 'Anamnesis próxima' },
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Examen físico' },
  { row: [{ shared: 'imc_fields' }] },
  ...kinesiologistPhysicalExamRows,
  { h3: 'Seguimiento' },
  { row: [text('current-state', 'Estado actual')] },
  { h3: 'Diagnóstico' },
  { row: [text('general-diagnosis', 'Diagnóstico general', COL12, { help: '' })] },
  { row: [text('treatment', 'Tratamiento', COL12, { help: '' })] },
  { h3: 'Indicaciones médicas' },
  { shared: 'recipe_fields' },
]

const kinesiologistFirstSessionV001: TemplateDefinition = [
  { h3: 'Antrometría' },
  { row: [{ shared: 'imc_fields' }] },
  { h3: 'Anamnesis próxima' },
  { row: [text('reason', 'Motivo de consulta', COL12, { help: '' })] },
  { h3: 'Anamnesis remota' },
  {
    row: [
      text('morbid', 'Antecedentes mórbidos', COL12, { help: '(Lesiones previas, diabetes, hipertensión, enfermedad vascular)' }),
      text('surgical-and-medical-antecedents', 'Antecedentes quirúrgicos y médicos', COL12, {
        help: '(Tumor, implantación de marcapasos, fármacos, alergias)',
      }),
      text('psicosocial-antecedents', 'Antecedentes psicosociales', COL12, {
        help: '(Trabajo, familia, actividades diarias, pasatiempo, hábitos)',
      }),
    ],
  },
  { h3: 'Examen físico' },
  ...kinesiologistPhysicalExamRows,
  { h3: 'Diagnóstico' },
  { row: [text('general-diagnosis', 'Diagnóstico general', COL12, { help: '' })] },
  { row: [text('treatment', 'Tratamiento', COL12, { help: '' })] },
  { h3: 'Indicaciones médicas' },
  { shared: 'recipe_fields' },
]

const matronControlV001: TemplateDefinition = [
  { h3: 'Anamnesis próxima' },
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Examen Físico' },
  { shared: 'basic_measure_fields' },
  { row: [text('physical-exam', 'Examen físico')] },
  { h3: 'Seguimiento' },
  { row: [text('current-state', 'Estado actual')] },
  { h3: 'Emisión de Recetas, Exámenes y Derivaciones' },
  { shared: 'recipe_fields' },
]

const matronFirstSessionV001: TemplateDefinition = [
  { h3: 'Anamnesis próxima' },
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Anamnesis remota' },
  {
    row: [
      text('morbid-antecedents', 'Antecedentes mórbidos', COL12, {
        help: '(Patologías crónicas, cáncer de mama u otros, alergias, uso de medicamentos)',
      }),
      text('habits', 'Hábitos', COL12, { help: '(Actividad física, tabaco, alcohol, otros)' }),
    ],
  },
  {
    row: [
      text('obstetric-gynecology-antecedents', 'Antecedentes gineco-obstétricos', COL12, {
        help: '(Menarquía, menopausia, ciclos menstruales, inicio actividad sexual, método anticonceptivo, resultados de examen papanicolaou)',
      }),
      text('obstetric-antecedents', 'Antecedentes obstétricos', COL12, { help: '(FO, patologías durante embarazo, descripción de partos)' }),
    ],
  },
  { h3: 'Examen físico' },
  { row: [{ shared: 'imc_fields' }, str('pressure', 'Presión', 'col-md-3 col-xs-12')] },
  { h3: 'Examen ginecológico obstétrico' },
  {
    row: [
      str('breasts', 'Mamas', 'col-xs-6', { help: '' }),
      str('abdomen', 'Abdomen', 'col-xs-6', { help: '' }),
      str('gynecologyc', 'Ginecológico', 'col-xs-6', { help: '' }),
      str('speculoscopy', 'Especuloscopía', 'col-xs-6', { help: '' }),
      str('vaginal-examination', 'Tacto Váginal', 'col-xs-6', { help: '' }),
      text('others', 'Otros', 'col-xs-6', { help: '' }),
    ],
  },
  { h3: 'Hipotesis diagnóstica' },
  { row: [text('diagnosis', 'Diagnostico')] },
  { h3: 'Emisión de Recetas, Exámenes y Derivaciones' },
  { shared: 'recipe_fields' },
]

const nurseControlV001: TemplateDefinition = [
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Signos vitales' },
  {
    row: [
      str('saturation', 'Saturación', 'col-xs-4', { help: '' }),
      str('fc', 'FC', 'col-xs-4', { help: '' }),
      str('fr', 'FR', 'col-xs-4', { help: '' }),
      str('arterial-pressure', 'P. Art', 'col-xs-4', { help: '' }),
      str('temperature', 'Temperatura', 'col-xs-4', { help: '' }),
      str('pulse', 'Pulso', 'col-xs-4', { help: '' }),
    ],
  },
  { h3: 'Examen físico' },
  {
    row: [
      text('neurological', 'Neurológico', 'col-xs-6', { help: '' }),
      text('head-face', 'Cabeza, cuello, cara', 'col-xs-6', { help: '' }),
    ],
  },
  { row: [text('torax', 'Tórax', 'col-xs-6', { help: '' }), text('abd', 'Abdómen', 'col-xs-6', { help: '' })] },
  {
    row: [
      text('ext-sup', 'Extremidades superiores', 'col-xs-6', { help: '' }),
      text('ext-inf', 'Extremedades inferiores', 'col-xs-6', { help: '' }),
    ],
  },
  {
    row: [
      text('evaluation', 'Evaluación Genitourinaria', 'col-xs-6', { help: '' }),
      text('skin', 'Piel y mucosas', 'col-xs-6', { help: '' }),
    ],
  },
  { h3: 'Evaluación' },
  { row: [text('evolution', 'Evolución de enfermería', COL12, { help: '' })] },
  { h3: 'Indicaciones médicas' },
  { shared: 'recipe_fields' },
]

const nurseControlV002: TemplateDefinition = [
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Signos vitales' },
  {
    row: [
      { key: 'saturation', kind: 'number', label: 'Saturación (%)', col: 'col-xs-4', help: '' },
      { key: 'fc', kind: 'number', label: 'FC (latidos/min)', col: 'col-xs-4', help: '' },
      { key: 'fr', kind: 'number', label: 'FR (respiraciones/minuto)', col: 'col-xs-4', help: '' },
      { key: 'arterial-pressure', kind: 'number', label: 'P. Art', col: 'col-xs-4', help: '' },
      { key: 'temperature', kind: 'number', label: 'Temperatura (ºC)', col: 'col-xs-4', help: '' },
    ],
  },
  { h3: 'Evolución de enfermería' },
  { row: [text('evolution', '', COL12, { help: '' })] },
  { h3: 'Indicaciones médicas' },
  { shared: 'recipe_fields' },
]

const nurseFirstSessionV001: TemplateDefinition = [
  { h3: 'Anamnesis próxima' },
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Anamnesis remota' },
  {
    row: [
      text('morbid-antecedents', 'Antecedentes mórbidos', 'col-xs-6', { help: '(Enfermedades crónicas, alergias, medicamentos)' }),
      text('habits', 'Hábitos', 'col-xs-6', { help: '(Actividad física, tabaco, alcohol, pasatiempos)' }),
    ],
  },
  {
    row: [
      text('surgical-and-medical-antecedents', 'Antecedentes quirúrgicos y médicos', 'col-xs-6', { help: '(Tumores, marcapasos, cirugias)' }),
      text('psicosocial-antecedents', 'Antecedentes psicosociales', 'col-xs-6', { help: '(Trabajo, familia, actividades diarias)' }),
    ],
  },
  { h3: 'Signos vitales' },
  {
    row: [
      { key: 'saturation', kind: 'number', label: 'Saturación (%)', col: 'col-xs-4', help: '' },
      { key: 'fc', kind: 'number', label: 'FC (latidos/min)', col: 'col-xs-4', help: '' },
      { key: 'fr', kind: 'number', label: 'FR (respiraciones/minuto)', col: 'col-xs-4', help: '' },
      { key: 'arterial-pressure', kind: 'number', label: 'P. Art', col: 'col-xs-4', help: '' },
      { key: 'temperature', kind: 'number', label: 'Temperatura (ºC)', col: 'col-xs-4', help: '' },
    ],
  },
  { h3: 'Examen físico' },
  {
    row: [
      str('neurological', 'Neurológico', 'col-xs-6', { help: '' }),
      str('head-face', 'Cabeza, cuello, cara', 'col-xs-6', { help: '' }),
    ],
  },
  { row: [str('torax', 'Tórax', 'col-xs-6', { help: '' }), str('abd', 'Abdómen', 'col-xs-6', { help: '' })] },
  {
    row: [
      str('ext-sup', 'Extremidades superiores', 'col-xs-6', { help: '' }),
      str('ext-inf', 'Extremedades inferiores', 'col-xs-6', { help: '' }),
    ],
  },
  {
    row: [
      str('evaluation', 'Evaluación genitourinaria', 'col-xs-6', { help: '' }),
      str('skin', 'Piel y mucosas', 'col-xs-6', { help: '' }),
    ],
  },
  { h3: 'Evolución de enfermería' },
  { row: [text('evolution', '', COL12, { help: '' })] },
  { h3: 'Indicaciones médicas' },
  { shared: 'recipe_fields' },
]

const nutritionistControlV001: TemplateDefinition = [
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Antrometría' },
  { row: [{ shared: 'imc_fields' }, { shared: 'weight_indicators_fields' }, str('cc', 'CC', 'col-md-3 col-xs-12')] },
  { row: [text('physical-exam', 'Examen físico')] },
  { row: [text('current-state', 'Estado Actual')] },
  { h3: 'Indicaciones médicas' },
  { shared: 'recipe_fields' },
]

const nutritionistFirstSessionV001: TemplateDefinition = [
  { h3: 'Antrometría' },
  { row: [{ shared: 'imc_fields' }, { shared: 'weight_indicators_fields' }, str('cc', 'CC', 'col-md-3 col-xs-12')] },
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Anamnesis remota' },
  { row: [text('psychosocial-antecedents', 'Antecedentes psicosociales', COL12, { help: '(Trabajo, familia, pasatiempos)' })] },
  { row: [text('morbid-antecedents', 'Antecedentes mórbidos', COL12, { help: '(Enfermedades, cirugias, embarazos)' })] },
  { h3: 'Anamnesis próxima' },
  { row: [text('medical-antecedents', 'Antecedentes médicos', COL12, { help: '(Enfermedades, medicamentos, hábitos, exámenes)' })] },
  {
    row: [
      text('nutritional-antecedents', 'Antecedentes nutricionales', COL12, {
        help: '(Historia de peso, sintomas gastrointestinales, alergias)',
      }),
    ],
  },
  { row: [text('24-hours-survey', 'Encuesta recordatorio 24 horas')] },
  { h3: 'Abordaje nutricional' },
  { row: [text('diagnosis', 'Diagnostico nutricional')] },
  { row: [text('goals', 'Metas nutricionales')] },
  { h3: 'Planificación alimentaria' },
  {
    row: [
      str('breakfast', 'Desayuno'),
      str('collation', 'Colación'),
      str('lunch', 'Almuerzo'),
      str('tea-time', 'Once'),
      str('dinner', 'Cena'),
    ],
  },
  { h3: 'Indicaciones médicas' },
  { shared: 'recipe_fields' },
]

const ophthalmologistControlV001: TemplateDefinition = [
  { h3: 'Evaluación visión' },
  {
    cols: [
      str('av-sc-od', 'AV SC OD', 'col-xs-6'),
      str('av-sc-oi', 'AV SC OI', 'col-xs-6'),
      str('av-cc-od', 'AV CC OD', 'col-xs-6'),
      str('av-cc-oi', 'AV CC OI', 'col-xs-6'),
    ],
  },
  { h3: 'Receta de lentes' },
  {
    cols: [
      str('od', 'OD', 'col-xs-4'),
      str('oi', 'OI', 'col-xs-4'),
      str('pd-pl', 'PD PL', 'col-xs-4'),
      str('add-pc', 'ADD PC', 'col-xs-6'),
      str('pd-pc', 'PD PC', 'col-xs-6'),
    ],
  },
  { h3: 'Otras evaluaciones' },
  {
    cols: [
      text('brukner', 'Test Brukner'),
      text('posterior-pole', 'Observación Polo Posterior'),
      str('tonometry-od', 'Tonometría OD', 'col-xs-6'),
      str('tonometry-oi', 'Tonometría OI', 'col-xs-6'),
    ],
  },
  { h3: 'Informacion óptico-contactologia-otro' },
  { cols: [text('info-oco', '')] },
  { h3: 'Indicaciones médicas' },
  { shared: 'recipe_fields' },
]

const ophthalmologistFirstSessionV001: TemplateDefinition = [
  { h3: 'Anamnesis Próxima' },
  { cols: [text('next-anamnesis', '')] },
  { h3: 'Anamnesis remota' },
  {
    cols: [
      text('morbid', 'Antecedentes mórbidos', COL12, { help: '(Lesiones previas, diabetes, hipertensión, enfermedad vascular, tumor)' }),
      text('surgical-and-medical-antecedents', 'Antecedentes quirúrgicos y médicos', COL12, {
        help: '(Tumor, implantación de marcapasos, fármacos, alergias)',
      }),
      text('psicosocial-antecedents', 'Antecedentes psicosociales', COL12, {
        help: '(Trabajo, familia, actividades diarias, pasatiempo, hábitos)',
      }),
    ],
  },
  { h3: 'Motivo de Consulta' },
  { cols: [text('reason', '')] },
  { h3: 'Evaluación visión' },
  {
    row: [
      str('av-sc-od', 'AV SC OD', 'col-xs-6'),
      str('av-sc-oi', 'AV SC OI', 'col-xs-6'),
      str('av-cc-od', 'AV CC OD', 'col-xs-6'),
      str('av-cc-oi', 'AV CC OI', 'col-xs-6'),
    ],
  },
  { h3: 'Receta de lentes' },
  {
    row: [
      str('od', 'OD', 'col-xs-4'),
      str('oi', 'OI', 'col-xs-4'),
      str('pd-pl', 'PD PL', 'col-xs-4'),
      str('add-pc', 'ADD PC', 'col-xs-6'),
      str('pd-pc', 'PD PC', 'col-xs-6'),
    ],
  },
  { h3: 'Otras evaluaciones' },
  {
    row: [
      text('brukner', 'Test Brukner'),
      text('posterior-pole', 'Observación Polo Posterior'),
      str('tonometry-od', 'Tonometría OD', 'col-xs-6'),
      str('tonometry-oi', 'Tonometría OI', 'col-xs-6'),
    ],
  },
  { h3: 'Informacion óptico-contactologia-otro' },
  { row: [text('info-oco', '')] },
  { h3: 'Indicaciones médicas' },
  { shared: 'recipe_fields' },
]

const pediatricianControlV001: TemplateDefinition = [{ include: 'general_practitioner/control/v001' }]

const pediatricianControlV002: TemplateDefinition = [{ include: 'general_practitioner/control/v002' }]

const pediatricianFirstSessionV001: TemplateDefinition = [
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Antecedentes Heredo Familiares' },
  { row: [text('paterns-antecedents', 'Paternos', 'col-xs-6'), text('matern-antecedents', 'Maternos', 'col-xs-6')] },
  { h3: 'Antecedentes Personales' },
  { row: [text('pathological-antecedents', 'Patológicos')] },
  { row: [text('no-pathological-antecedents', 'No Patológicos')] },
  { row: [text('perinatal-antecedents', 'Perinatales')] },
  { h3: 'Exploración Física' },
  { shared: 'basic_measure_fields' },
  { shared: 'physical_analysis_fields' },
  { row: [text('diagnosis', 'Diagnostico')] },
  { row: [text('indications', 'Indicaciones')] },
  { h3: 'Emisión de Recetas, Exámenes y Derivaciones' },
  { shared: 'recipe_fields' },
]

const psychologistSessionsV001: TemplateDefinition = [
  { cols: [text('relevant-records', 'Antecedentes relevantes')] },
  { cols: [text('general-aspects', 'Aspectos generales')] },
  { cols: [text('next-session-targets', 'Objetivos de próxima sesión')] },
]

const psychologistEpicrisisV001: TemplateDefinition = [
  { cols: [text('admission-reason', 'Motivo de Ingreso')] },
  { cols: [text('exit-reason', 'Motivo de Salida')] },
  { cols: [text('general-records', 'Antecedentes Generales')] },
  { h3: 'Indicaciones médicas' },
  { shared: 'recipe_fields' },
]

const psychologistEvaluationsV001: TemplateDefinition = [
  { cols: [text('reason', 'Motivo de consulta')] },
  { cols: [text('relevant-records', 'Antecedentes relevantes')] },
  { cols: [text('diagnostic-hypothesis', 'Hipótesis Diagnóstica')] },
  { h3: 'Indicaciones médicas' },
  { shared: 'recipe_fields' },
]

const speechTherapistControlV001: TemplateDefinition = [
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Síntomas vocales' },
  {
    row: [
      text('diagnosis-main-cause', 'Síntoma principal', COL12, {
        help: '(Ejemplos: Disfonía, dolor, acidez, parastesia, cierre de garganta, afonia, ardor, cambio de voz, secreción, sensación de cuerpo extraño.)',
      }),
    ],
  },
  { row: [text('diagnosis-causes', 'Causa', COL12, { help: '' })] },
  { h3: 'Diagnóstico' },
  { row: [text('diagnosis', 'Diagnóstico', COL12, { help: '' })] },
  { h3: 'Indicaciones médicas' },
  { shared: 'recipe_fields' },
]

const speechTherapistFirstSessionV001: TemplateDefinition = [
  { h3: '' },
  { row: [text('reason', 'Motivo de consulta')] },
  { h3: 'Antecedentes mórbidos' },
  {
    row: [
      text('diseases', 'Enfermedad relevante', 'col-xs-6', { help: '' }),
      text('antecedents', 'Accidentes y/o hospitalizaciones', 'col-xs-6', { help: '' }),
    ],
  },
  {
    row: [
      text('medicaments', 'Medicamentos', 'col-xs-6', { help: '' }),
      text('treatments', 'Tratamientos', 'col-xs-6', { help: '' }),
    ],
  },
  { h3: 'Antecedentes médicos' },
  { row: [text('medical-antecedents', 'Antecedentes médicos', COL12, { help: '(Ejemplos: Alergia, asma, acidez, sinusitis, reflujo.)' })] },
  { h3: 'Síntomas vocales' },
  {
    row: [
      text('diagnosis', 'Síntoma principal', COL12, {
        help: '(Ejemplos: Disfonía, dolor, acidez, parastesia, cierre de garganta, afonia, ardor, cambio de voz, secreción,sensación de cuerpo extraño.)',
      }),
    ],
  },
  { row: [text('diagnosis-causes', 'Causa', COL12, { help: '' })] },
  { h3: 'Abuso y mal uso vocal' },
  {
    row: [
      text('sustances-consume', 'Consumo de sustancias', 'col-xs-6', { help: '' }),
      text('medicaments', 'Medicamentos', 'col-xs-6', { help: '' }),
      text('working-enviroment', 'Ambiente laboral', COL12, {
        help: '(Ejemplos: Ambiente húmedo o seco, ruidos competitivos, presencia de irritantes, grita, imita voces, sonidos no verbales...)',
      }),
    ],
  },
  { h3: 'Diagnóstico' },
  { row: [text('diagnosis', 'Diagnóstico', COL12, { help: '' })] },
  { h3: 'Indicaciones médicas' },
  { shared: 'recipe_fields' },
]

export const TEMPLATES: Record<string, TemplateDefinition> = {
  'general_practitioner/control/v001': generalPractitionerControlV001,
  'general_practitioner/control/v002': generalPractitionerControlV002,
  'general_practitioner/control/v003': generalPractitionerControlV003,
  'general_practitioner/first_session/v001': generalPractitionerFirstSessionV001,
  'general_practitioner/first_session/v002': generalPractitionerFirstSessionV002,
  'general_practitioner/first_session/v003': generalPractitionerFirstSessionV003,
  'kinesiologist/control/v001': kinesiologistControlV001,
  'kinesiologist/first_session/v001': kinesiologistFirstSessionV001,
  'matron/control/v001': matronControlV001,
  'matron/first_session/v001': matronFirstSessionV001,
  'nurse/control/v001': nurseControlV001,
  'nurse/control/v002': nurseControlV002,
  'nurse/first_session/v001': nurseFirstSessionV001,
  'nutritionist/control/v001': nutritionistControlV001,
  'nutritionist/first_session/v001': nutritionistFirstSessionV001,
  'ophthalmologist/control/v001': ophthalmologistControlV001,
  'ophthalmologist/first_session/v001': ophthalmologistFirstSessionV001,
  'pediatrician/control/v001': pediatricianControlV001,
  'pediatrician/control/v002': pediatricianControlV002,
  'pediatrician/first_session/v001': pediatricianFirstSessionV001,
  'psychologist/sessions/v001': psychologistSessionsV001,
  'psychologist/epicrisis/v001': psychologistEpicrisisV001,
  'psychologist/evaluations/v001': psychologistEvaluationsV001,
  'speech_therapist/control/v001': speechTherapistControlV001,
  'speech_therapist/first_session/v001': speechTherapistFirstSessionV001,
}

export function getTemplate(professionKey: string, sessionKey: string, versionKey: string): TemplateDefinition | null {
  return TEMPLATES[`${professionKey}/${sessionKey}/v${versionKey}`] ?? TEMPLATES[`${professionKey}/${sessionKey}/${versionKey}`] ?? null
}
